import {
  VIEW_PROPOSAL,
  CLOSE_VIEW_PROPOSAL,
  OPEN_COMPLETE_DEAL_FORM,
  CLOSE_COMPLETE_DEAL_FORM,
  OPEN_REVIEW_CONTENT_VIEW,
  CLOSE_REVIEW_CONTENT_VIEW,
  RELEASE_ESCROW_PROCESS_SUCCESS,
  OPEN_DISPUTE_SUCCESS,
  ACCEPT_DEAL_STARTED,
  ACCEPT_DEAL_SUCCESS,
  ACCEPT_DEAL_FAILURE
} from '../constants';

const initState = {
  viewProposal: false,
  dealProposal: null,
  viewCompleteDealForm: false,
  dealToComplete: null,
  viewReviewContent: false,
  dealWithContent: null,
  acceptingDealInProgress: false
};

const dealStateReducer = (state = initState, action) => {
  switch (action.type) {
    case VIEW_PROPOSAL:
      return {
        ...state,
        viewProposal: true,
        dealProposal: action.payload.deal
      };
    case ACCEPT_DEAL_STARTED:
      return {
        ...state,
        acceptingDealInProgress: true
      };
    case ACCEPT_DEAL_SUCCESS:
      return {
        ...initState
      };
    case ACCEPT_DEAL_FAILURE:
      return {
        ...initState
      };
    case CLOSE_VIEW_PROPOSAL:
      return {
        ...state,
        viewProposal: false
      };
    case OPEN_COMPLETE_DEAL_FORM:
      return {
        ...state,
        viewCompleteDealForm: true,
        dealToComplete: action.payload.deal
      };
    case CLOSE_COMPLETE_DEAL_FORM:
      return {
        ...initState
      };
    case OPEN_REVIEW_CONTENT_VIEW:
      return {
        ...state,
        viewReviewContent: true,
        dealWithContent: action.payload.deal
      };
    case CLOSE_REVIEW_CONTENT_VIEW:
      return {
        ...initState
      };
    case RELEASE_ESCROW_PROCESS_SUCCESS: {
      return {
        ...initState
      };
    }
    case OPEN_DISPUTE_SUCCESS:
      return {
        ...initState
      };
    default:
      return state;
  }
};

export default dealStateReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/dealStateReducer.js